import _ from 'lodash';
import cssUtil from 'gw-portals-util-js/CssUtil';
import styles from './PaQuickQuoteAddress-hashed.scss';
import templateStr from 'text!./PaQuickQuoteAddress.html';
import GeoCodeService from 'edge/platform/map/GeoCodeService';
import loadGoogleMapsAPI from 'gw-portals-google-maps-js';

export default [
    () => {
        function isIncompleteButNotEmpty(address) {
            if (address.value !== '' && _.isEmpty(address.value)) {
                return false;
            }
            return !address.aspects.subtreeValid;
        }

        return {
            restrict: 'E',
            template: cssUtil.hashTemplate(templateStr, styles),
            scope: {
                address: '=',
                isActive: '&',
                isPanelValid: '&',
                transitionFn: '&',
                flow: '='
            },
            controller: ['$scope', 'TranslateService', 'quickquote.QuickQuoteService', 'LocaleService',
                'addressSettings', 'AddressUtil', 'defaultLocaleDetails', '$interval', '$http', '$log', '$q',
                async ($scope, TranslateService, QuickQuoteService, LocaleService, addressSettings, AddressUtil, defaultLocaleDetails, $interval, $http, $log, $q) => {
                    await loadGoogleMapsAPI();

                    $scope.defaultLocation = {
                        lat: defaultLocaleDetails.mapCenter.lat,
                        lng: defaultLocaleDetails.mapCenter.lon
                    };
                    $scope.usingCurrentLocationForAddress = false;
                    $scope.searchForLocation = false;
                    $scope.isInManualEntryMode = false;
                    $scope.msOfInactivityBeforeSearching = addressSettings.msOfInactivityBeforeSearching;

                    $scope.switchToManualEntryMode = () => {
                        const address = $scope.address;

                        if (!address.value || _.isEmpty(address.value)) {
                            const localeCountryCode = LocaleService.getCountry().code;
                            address.value = {
                                country: localeCountryCode
                            };
                        }
                        $scope.isInManualEntryMode = true;
                    };

                    $scope.switchToSearch = () => {
                        $scope.isInManualEntryMode = false;
                    };

                    if (isIncompleteButNotEmpty($scope.address)) {
                        $scope.switchToManualEntryMode();
                    }

                    $scope.addressLookup = {
                        getMatches: function (userInput) {
                            return QuickQuoteService.findAddress(userInput);
                        },
                        toString: address => {
                            if (_.isEmpty(address)) {
                                return '';
                            }
                            return AddressUtil.format(address);
                        }
                    };

                    $scope.getCurrentLocation = () => {
                        $scope.usingCurrentLocationForAddress = true;
                        $scope.searchForLocation = true;
                        $scope.newMapCenter = {
                            longitude: null,
                            latitude: null
                        };
                    };

                    $scope.hideMap = () => {
                        $scope.usingCurrentLocationForAddress = false;
                        $scope.searchForLocation = false;
                    };

                    /**
                     * scope.isMapsLoaded
                     * Checks if the google maps API has been loaded
                     *
                     * @returns {true} if maps has been successfully loaded, {false} otherwise.
                     */
                    $scope.isMapsLoaded = false;

                    const interval = $interval(() => {
                        // waiting until GOOGLE MAPS are loaded
                        if (typeof window.google === 'object' && typeof window.google.maps === 'object') {
                            $scope.isMapsLoaded = true;
                            $interval.cancel(interval);
                        }
                    }, 100);

                    $scope.newMapCenter = {
                        longitude: $scope.address.center ? $scope.address.center.longitude : null,
                        latitude: $scope.address.center ? $scope.address.center.latitude : null
                    };

                    $scope.getDeviceLocation = (longLat) => {
                        if (longLat && longLat.coords.longitude && longLat.coords.latitude) {
                            const geoCodeService = new GeoCodeService($http, $log, $q);
                            geoCodeService.getGeoCodedAddr(longLat.coords.latitude, longLat.coords.longitude)
                                .then((address) => {
                                    delete address.address1;
                                    delete address.address2;
                                    $scope.address.value = address;
                                    $scope.address.value.addressType = 'home';
                                    /* We set the country to the locale country code because the geocode service could
                                    *  get the wrong location and overwrite the country. The country code is not exposed
                                    *  in the UI so the user could be blocked from getting a quote even if they correct
                                    *  the address manually. We assume that the xcenters are running in one country.
                                    */
                                    $scope.address.value.country = LocaleService.getCountry().code;
                                });
                        }
                    };

                    $scope.$watch('address.value', (newVal) => {
                        if (!_.isEmpty(newVal)) {
                            $scope.address.value.addressType = 'home';
                            if (window.google && window.google.maps) {
                                const geoCodeService = new GeoCodeService($http, $log, $q);
                                geoCodeService.geocodeAddress(newVal).then(coords => {
                                    $scope.newMapCenter = {
                                        longitude: coords.longitude,
                                        latitude: coords.latitude
                                    };
                                    $scope.searchForLocation = true;
                                });
                            }
                        }
                    });
                }]
        };
    }
];
